export const KYC_DECLINED_EVENTS = {
  VIEW_KYC_DECLINED_PAGE: 'view_kyc_declined',
  SELECT_KYC_DECLINED_SUPPORT: 'select_kyc_declined_support',
} as const;
